<template>
  <v-row class="conteudo-aula-infantil">
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Campos de experiências</e-label>
      <v-col>
        <v-chip
          v-for="(campo, index) in aula.campos_de_experiencias"
          :key="'campo-' + index"
          class="ma-2"
          color="indigo"
          outlined
        >
          {{ campo }}
        </v-chip>
      </v-col>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Rotina Permanente</e-label>
      <v-col>
        <v-chip
          v-for="(rotina, index) in rotinas"
          :key="'rotina-' + index"
          class="ma-2"
          color="teal"
          outlined
        >
          {{ rotina }}
        </v-chip>
      </v-col>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Eixos temáticos (Conteúdos)</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.eixos }}</p>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Estratégias (Sala/Casa)</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.estrategias }}</p>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Recursos</e-label>
      <v-col>
        <template>
          <v-chip
            v-for="(recurso, index) in aula.recursos"
            :key="'recurso-' + index"
            class="ma-2"
            color="primary"
          >
            {{ recurso }}
          </v-chip>
        </template>
      </v-col>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Recursos Adicionais</e-label>
      <v-col>
        <v-chip
          v-for="(recurso, index) in aula.novos_recursos"
          :key="'novo-recurso-' + index"
          class="ma-2"
          color="secondary"
        >
          {{ recurso }}
        </v-chip>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ConteudoAulaInfantil",
  props: {
    aula: {
      type: Object,
      required: true,
    },
  },
  computed: {
    camposDeExperiencias() {
      return (this.aula.campos_de_experiencias || []).filter((item) => item !== null);
    },
    rotinas() {
      return (this.aula.rotina_permanente || []).filter((item) => item !== null);
    },
  },
};
</script>

<style scoped>
.saltar-linha {
  white-space: pre-line;
}
.conteudo-aula-infantil {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}
</style>
